.bd{justify-content:flex-end;}